var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps-card-footer clearfix"},[_c('div',{staticClass:"justify-content-start"},[_vm._t("footerLeft")],2),_c('div',{staticClass:"justify-content-end"},[_vm._t("footerRight")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }